import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/marketplace/',
    name: 'Marketplace',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc =
          store.getters['identity/hasAccessAll'](['marketplace:read'])
        if (!acc) return next({ name: 'Liveview' })
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/marketplace'),
  },

  {
    path: '/marketplace/product/detail',
    name: 'Marketplace Product Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        const acc =
          store.getters['identity/hasAccessAll'](['marketplace:read'])
        if (!acc) return next({ name: 'Liveview' })
        Helper.methods.userLogging('Access', _)
        next()
      },
    },
    component: () => import('@/router/views/marketplace/components/ProductCard/ProductDetail'),
  },
]
